import styled from 'styled-components'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInputSet'

const CheckBoxEtcInputSet = styled(CheckBoxInputSet)`
  margin-top: 10px;
  padding: 0;
`

export default CheckBoxEtcInputSet
